import React, { useState } from 'react';
import SectionHeader from './SectionHeader';
import { faqs } from '../data';
import SafeIcon from '../common/SafeIcon';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-24 bg-cream-paper border-t border-gray-200">
      <div className="max-w-3xl mx-auto px-6">
        <SectionHeader title="Common Questions" subtitle="Curiosity rewarded." />
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-gray-200 bg-white">
              <button 
                className="w-full flex justify-between items-center p-6 text-left cursor-pointer hover:bg-gray-50 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
              >
                <span className="font-serif font-bold text-lg text-espresso">{faq.q}</span>
                <SafeIcon 
                  name="ChevronDown" 
                  className={`transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} 
                />
              </button>
              {openIndex === index && (
                <div className="p-6 pt-0 text-gray-600 font-sans leading-relaxed border-t border-gray-100 mt-2">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;